import { EmailVerificationNotice } from "@/features/auth"
import { createFileRoute } from "@tanstack/react-router"

function VerifyEmailPage() {
  return (
    <EmailVerificationNotice
      showResendButton={true}
      autoRedirectOnVerification={true}
      redirectTo="/"
    />
  )
}

export const Route = createFileRoute("/verify-email")({
  component: VerifyEmailPage,
})
